import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { MainContentAuthWrapper } from "./components/content/MainContentAuthWrapper";
import GuestVideoPage from "./components/guest/GuestVideoPage";
import GymCompanionPrivacyPage from "./components/privacy/GymCompanionPrivacyPage";
import NavMenuComponent from "./components/navMenu/navMenu.component";
import "./App.css";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { TFTheme } from "./TFTheme";

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider theme={TFTheme}>
        <CssBaseline />
        <NavMenuComponent />
        <Routes>
          <Route path="/guest/video42" element={<GuestVideoPage />} />
          <Route
            path="/applications/gym-companion/privacy-policy"
            element={<GymCompanionPrivacyPage />}
          />
          <Route
            path="/privacy"
            element={<Navigate to="/applications/gym-companion/privacy-policy" replace />}
          />
          <Route path="/*" element={<MainContentAuthWrapper />} />
        </Routes>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
